


















import { defineComponent, getCurrentInstance, ref, watch } from "@vue/composition-api";
import { isAfter, addDays } from "date-fns";
import useAuthUser from "@/hooks/useAuthUser";
import AppStorage from "@/lib/appStorage";
import { isIOS, isWebApp, iosVersion, getNotificationsPermissions } from "@/lib/browserUtils";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";

const COUNT_KEY = "PUSH_NOTIFICATIONS_DECLINE_COUNT";
const LAST_DATE_KEY = "PUSH_NOTIFICATIONS_DECLINE_DATE";

export default defineComponent({
  name: "ModalPushNotificationsHelper",
  components: { BaseIcon, BaseButton, BaseConfirm },
  setup() {
    const vm = getCurrentInstance();
    const show = ref(false);

    const onConfirm = () => {
      show.value = false;
      vm?.$router.push({ name: "pushNotificationsHowTo" });
    };

    const onClose = () => {
      AppStorage.setNumber(LAST_DATE_KEY, new Date().getTime());
      AppStorage.setNumber(COUNT_KEY, AppStorage.getNumber(COUNT_KEY, 0) + 1);
      show.value = false;
      vm?.$router.push({ name: "pushNotificationsSettings" });
    };
    const { authUser } = useAuthUser();
    const tryToShow = () => {
      if (!config.webPushNotificationsPublicKey) {
        return;
      }
      const showCount = AppStorage.getNumber(COUNT_KEY, 0);
      const lastShowDateTimestamp = AppStorage.getNumber(LAST_DATE_KEY, 0);

      const countCheck = showCount < 3;
      let dateCheck = true;
      if (lastShowDateTimestamp) {
        const dateToCheck = new Date();
        const lastShowDate = new Date(lastShowDateTimestamp);
        dateCheck = isAfter(dateToCheck, addDays(lastShowDate, 1));
      }
      const isNotificationDisabledCheck = getNotificationsPermissions() !== "granted";
      const version = iosVersion().version;
      const subVersion = parseInt(iosVersion().info.split(".")[1] ?? "0");

      if (
        authUser.value &&
        isIOS() &&
        dateCheck &&
        countCheck &&
        isNotificationDisabledCheck &&
        (!isWebApp || version < 16 || subVersion < 5)
      ) {
        show.value = true;
      }
    };
    tryToShow();
    watch(authUser, (newValue, prevValue) => {
      if (!prevValue && newValue) {
        tryToShow();
      }
    });

    return { show, onClose, onConfirm };
  },
});
